import React from 'react';

interface SkeletonLoaderProps {
  variant?: 'card' | 'text' | 'table-row' | 'circle';
  count?: number;
  className?: string;
}

export const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({
  variant = 'text',
  count = 1,
  className = '',
}) => {
  const items = Array.from({ length: count });

  if (variant === 'card') {
    return (
      <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 ${className}`}>
        {items.map((_, i) => (
          <div key={i} className="bg-white rounded-xl shadow-card p-6 animate-pulse">
            <div className="w-14 h-14 rounded-full bg-gray-200 mx-auto mb-4" />
            <div className="h-5 bg-gray-200 rounded w-3/4 mx-auto mb-3" />
            <div className="h-4 bg-gray-200 rounded w-full mb-2" />
            <div className="h-4 bg-gray-200 rounded w-5/6 mb-6" />
            <div className="h-9 bg-gray-200 rounded w-28 mx-auto" />
          </div>
        ))}
      </div>
    );
  }

  if (variant === 'table-row') {
    return (
      <div className={`space-y-3 ${className}`}>
        {items.map((_, i) => (
          <div key={i} className="flex gap-4 animate-pulse">
            <div className="h-4 bg-gray-200 rounded flex-1" />
            <div className="h-4 bg-gray-200 rounded w-24" />
            <div className="h-4 bg-gray-200 rounded w-20" />
            <div className="h-4 bg-gray-200 rounded w-32" />
          </div>
        ))}
      </div>
    );
  }

  if (variant === 'circle') {
    return (
      <div className={`flex items-center justify-center ${className}`}>
        <div className="w-12 h-12 rounded-full bg-gray-200 animate-pulse" />
      </div>
    );
  }

  // text variant
  return (
    <div className={`space-y-3 animate-pulse ${className}`}>
      {items.map((_, i) => (
        <div key={i} className="h-4 bg-gray-200 rounded" style={{ width: `${85 - i * 10}%` }} />
      ))}
    </div>
  );
};
